interface AccountOptionalTerms {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
}

export interface AccountProvider {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  provider: string;
  pId: string;
}

export class AccountDto {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;

  // 서비스 유형
  service: string;

  // 임시 비밀번호 여부
  isTemporaryPassword: boolean;

  // 필수약관 동의 일시
  requiredTermsAgreedAt: Date;

  // 계정 잠금 일시. 비밀번호를 잘못 입력해 정해진 로그인 시도 횟수 초과 시 일시가 기입된다.
  lockedAt: Date | null;

  // 유저 활성화 여부
  isActivated: boolean;

  // 푸시 수신 여부
  pushReceivable: boolean;

  // 문자 수신 여부
  messageReceivable: boolean;

  // 알림톡 수신 여부
  kakaoReceivable: boolean;

  // 이메일 수신 여부
  emailReceivable: boolean;

  // HHMM
  disturbForbiddenHHMMStartAt: string;

  // HHMM
  disturbForbiddenHHMMEndAt: string;

  // 선택약관을 마지막으로 읽은 날짜
  optionalTermsReadAt: Date;

  // 마지막 로그인 일시
  lastLoggedInAt: string | null;

  // 로그인 실패 횟수
  signInFailCount: number;

  // 비밀번호 변경 일시
  passwordChangedAt: Date;

  // 마케팅 동의 여부
  accountOptionalTerms: AccountOptionalTerms;

  accountProviders?: AccountProvider[];
}
